import { useEffect, useState } from "react";
import { ListCard, MapViewFlyOut } from "../Shared";
import moment from "moment";
import { useGetTripsTrackQuery } from "../services";
import TripsMap from "../Trips/TripsMap";
import { QIDragAndDropDetails } from "../../../components";
import { Dnd, MinimisedTab, useDndContainer, WindowTab } from "../Dnd";
import { extractKeyValuePairs, displayKeyName, valueFormatter } from "../utils";
import { useVariableDataQuery } from "../../../hooks/QIVariableDataQuery";
import { FMDPStorage } from "../../../shared/helper";
import { getLocalizedString } from "../../../shared/translation";
import { useGetPluginsQuery } from "../../ManagementPortal/services";
import { PluginContainer } from "../../Plugins";
import Scrollbars from "react-custom-scrollbars-2";
import { useSelector, useDispatch } from "react-redux";
import { setGlobalResetCount, setCurrentTabGlobal } from "../../../reduxStore/features";
import { hasAdminRole } from "../utils";

export const ActivitiesAlternateContainer = ({}) => {
  const selectedPlateNumbers = FMDPStorage.get("selected-plate-numbers")?.length
    ? FMDPStorage.get("selected-plate-numbers")
    : [""];
  const [dockAlign, setDockAlign] = useState("cross");
  const [maximizeMinimize, setmaximizeMinimize] = useState(false);
  const [selectedRangeLocal, setSelectedRange] = useState({
    startDate: moment().subtract(24, "hours"),
    endDate: moment(),
  });
  const [mapProvider, setMapProvider] = useState();
  const [mapboxAccessToken, setMapBoxAccessToken] = useState();
  const [googleMapsApiKey, setGoogleMapsApiKey] = useState();
  const [trackMapRef, setTrackMapRef] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [resetCount, setResetCount] = useState(0);
  const [clientId, setClientId] = useState(null);
  const [highlight, setHighlight] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [deviceId, setDeviceId] = useState(null);
  const [tripTime, setTripTime] = useState(null);
  const [showEventsDetails, setShowEventsDetails] = useState(false);
  const [mode, setMode] = useState("PARKED");
  const [mapExpand, setMapExpand] = useState(false);
  const [mapPoint, setMapPoint] = useState(null);
  const [activitySearch, setActivitySearch] = useState("");
  const [showTrack, setShowTrack] = useState(false);
  const [currentTab, setCurrentTab] = useState("Map");
  const [clientConfig, setClientConfig] = useState({});

  const dispatch = useDispatch();
  let globalDockAlign = useSelector((state) => state.common.globalDockAlign);

  let selectedRange = useSelector((state) => state.common.selectedRange);
  let globalResetCount = useSelector((state) => state.common.globalResetCount);
  let configJson = useSelector((state) => state.common.globalCustomJson);

  //Pagination
  const pagination = { page, perPage, onPageChange: setPage, onPerPageChange: setPerPage };

  const { variableData } = useVariableDataQuery();

  const { activeBoxes, addNewBox, removeBox, revertBox, isItemsDragging, handleDragChange } =
    useDndContainer();

  //Get Client ID & Config
  useEffect(() => {
    const selectedClientId = JSON.parse(localStorage.getItem("selected-app-id"));
    const currentUser = JSON.parse(localStorage.getItem("current-user"))?.client_apps?.find(
      (item) => {
        return item.id === selectedClientId;
      }
    );
    setClientId(currentUser?.client?.id);
    try {
      if (currentUser?.client?.config_json) {
        const mapProvider = JSON.parse(currentUser?.client?.config_json)?.tracking?.web?.map;
        const clientConfig = configJson;

        if (mapProvider?.provider === "mapbox" && mapProvider?.mapboxAccessToken) {
          setClientConfig(clientConfig);
          setMapProvider("mapbox");
          setMapBoxAccessToken(mapProvider.mapboxAccessToken);
          setGoogleMapsApiKey(null);
        } else if (mapProvider?.provider === "google" && mapProvider?.googleMapsApiKey) {
          setClientConfig(clientConfig);
          setMapProvider("google");
          setMapBoxAccessToken(null);
          setGoogleMapsApiKey(mapProvider.googleMapsApiKey);
        } else {
          setClientConfig(clientConfig);
          setMapProvider("qiMap");
          setMapBoxAccessToken(null);
          setGoogleMapsApiKey(null);
        }
      }
    } catch (e) {
      console.log(e);
    }

    //clean up client id on component unmount
    return () => setClientId(null);
  }, []);

  //clean up calendar value on compoonent unmount
  useEffect(() => {
    return setResetCount((prev) => prev + 1);
  }, []);

  //on page change remvove row selection

  useEffect(() => {
    removeSelection();
  }, [page]);

  //If search changes, reset page to 1
  useEffect(() => {
    if (activitySearch) {
      setPage(1);
    }
  }, [activitySearch]);

  //If selectedRange changes, reset page to 1
  useEffect(() => {
    setPage(1);
  }, [selectedRange]);

  const currentUser = FMDPStorage.get("current-user");

  const selectedAppId = FMDPStorage.get("selected-app-id");
  const getFilterList = (type) => {
    const isAdmin = hasAdminRole(currentUser, selectedAppId);

    if (type === "checkAdmin") {
      return isAdmin;
    } else {
      if (!isAdmin && type === "device") {
        return "";
      } else if (!isAdmin && type === "plateNo") {
        return selectedPlateNumbers?.length > 0 ? selectedPlateNumbers : "";
      } else {
        return "";
      }
    }
  };

  const { data, error, isLoading, isSuccess } = useGetTripsTrackQuery(
    clientId && {
      isAdmin: getFilterList("checkAdmin"),
      plate_number: selectedPlateNumbers,
      startTime: moment(selectedRange.startDate).valueOf(),
      endTime: moment(selectedRange.endDate).valueOf(),
      clientId: clientId,
      page: page - 1,
      per_page: perPage,
      search: true,
      q: activitySearch?.toUpperCase(),
    }
  );

  const removeSelection = () => {
    setSelectedRowId(null);
    setDeviceId(null);
    setTripTime(null);
    setShowEventsDetails(false);
    setDockAlign("cross");
  };

  const onRowClick = (data, id) => {
    if (selectedRowId === id) {
      removeSelection();
    } else {
      setSelectedRowId(id);
      setDeviceId(data?.data?.source_id);
      setTripTime({
        start_time: data?.data?.start_time,
        end_time: data?.data?.end_time || data?.data?.last_time,
      });
      setShowEventsDetails(data?.data);
      setMode(data?.mode);
      dockAlign === "cross" && setDockAlign(globalDockAlign);

      globalDockAlign === "pop-out" && addNewBox(100);
    }
  };

  const openDeviceModal = () => {
    setShowDetails(false);
    addNewBox(100);
  };

  const getListDetails = () => {
    const keyValues = extractKeyValuePairs(showEventsDetails);
    const renderDetails = keyValues.map((pair) => {
      const key = Object.keys(pair)[0];
      let value = pair[key];

      return (
        <>
          {value !== null && !key.startsWith("_") && (
            <li className="details-block_other-data_item">
              <strong title={key} className="details-block_other-data_item_label">
                {getLocalizedString(key, displayKeyName(variableData, key))}
              </strong>
              <span title={value} className="details-block_other-data_item_value">
                {valueFormatter(key, value, variableData)}
              </span>
            </li>
          )}
        </>
      );
    });
    return (
      <section className="details-block_data-container activites-details-list">
        <Scrollbars>
          <ul className="qi-list-view details-block_data details-block_other-data">
            {renderDetails}
          </ul>
        </Scrollbars>
      </section>
    );
  };

  const funSetActive = () => {
    setCurrentTab("Map");
  };

  const showdetailsTabs = (tab) => {
    setCurrentTab(tab);
  };

  const { data: dataPlugins = { data: [], total_count: 0 } } = useGetPluginsQuery({
    page,
    per_page: perPage,
    order_by: "plugins.created_at",
    order_dir: "desc",
  });

  const addPlugins = dataPlugins.data.filter(
    (plugin) =>
      plugin.tracker_containers.map((s) => parseInt(s, 10)).includes(4) && plugin.is_enabled
  );
  const isPluginTab = addPlugins.some((plugin) => plugin.name === currentTab);
  const selectedPlugin = addPlugins.find((plugin) => plugin.name === currentTab);

  useEffect(() => {
    removeSelection();
  }, [selectedRange]);

  useEffect(() => {
    dispatch(setCurrentTabGlobal(currentTab));
  }, [currentTab]);

  return (
    <>
      <div className="tracking-trips activities-tab">
        <div className="tracking-app-main-container">
          <MapViewFlyOut
            data={data?.activities || []}
            resetCount={resetCount}
            setResetCount={setResetCount}
            selectedRange={selectedRange}
            setSelectedRange={setSelectedRange}
            error={error}
            listType={"Trips"}
            pagination={{ ...pagination, count: data?.total_count }}
            selectedPage={"Activities"}
            isLoading={isLoading}
            title={"Activities"}
            search_by_message="Plate No.,IMEI, Driver Name, Modes, Device Name"
            setMapExpand={setMapExpand}
            simpleSearch={activitySearch}
            setSimpleSearch={setActivitySearch}
            setDetails={setShowEventsDetails}
            setSelectedRowId={setSelectedRowId}
            setDeviceId={setDeviceId}
            setDockAlign={setDockAlign}
          >
            <Scrollbars>
              <ListCard
                data={data?.activities || []}
                cardType="Activities"
                onRowClick={onRowClick}
                highlight={highlight}
                setHighlight={setHighlight}
                selectedRowId={selectedRowId}
              />
            </Scrollbars>
          </MapViewFlyOut>
          <article className={`tracking-app-main-container_block ${currentTab}`}>
            {addPlugins?.length > 0 && (
              <nav className="map-view-tabs">
                <ul className="map-and-details_tabs">
                  {addPlugins.map((plugin, index) => (
                    <li key={index}>
                      <span
                        className={`map-and-details_tabs_item ${
                          currentTab === plugin.name && "active"
                        }`}
                        onClick={() => showdetailsTabs(plugin.name)}
                      >
                        {getLocalizedString("plugins", plugin.name)}
                      </span>
                    </li>
                  ))}
                </ul>
              </nav>
            )}

            <article
              className={`map-and-details ${dockAlign} ${
                maximizeMinimize ? "minimized-details" : ""
              }`}
            >
              {currentTab === "Map" ? (
                <TripsMap
                  dockAlign={dockAlign}
                  mapExpand={mapExpand}
                  deviceId={deviceId}
                  selectedRange={tripTime}
                  maximizeMinimize={maximizeMinimize}
                  mapProvider={mapProvider}
                  mapboxAccessToken={mapboxAccessToken}
                  googleMapsApiKey={googleMapsApiKey}
                  clientConfig={clientConfig}
                />
              ) : isPluginTab ? (
                <PluginContainer selectedPlugin={selectedPlugin} />
              ) : null}

              {showEventsDetails && (
                <article className={`details-block`}>
                  <QIDragAndDropDetails
                    setDetails={setShowEventsDetails}
                    setPopup={openDeviceModal}
                    deviceData={showEventsDetails || {}}
                    removeRowSelection={removeSelection}
                    setDockAlign={setDockAlign}
                    dockAlign={dockAlign}
                    deviceId={deviceId}
                    setDeviceId={setDeviceId}
                    showTrack={showTrack}
                    setShowTrack={setShowTrack}
                    headerName={"Plate Number"}
                    listDetails={getListDetails()}
                    selectedVehiclePlate={showEventsDetails?.plate_number}
                    maximizeMinimize={maximizeMinimize}
                    setmaximizeMinimize={setmaximizeMinimize}
                    realTimedata={{}}
                  />
                </article>
              )}
            </article>
          </article>
          <div>
            <MinimisedTab layoutName="trackingLayout" />
          </div>
        </div>
        {dockAlign === "pop-out" && (
          <Dnd
            layoutName="trackingLayout"
            isItemsDragging={isItemsDragging}
            handleDragChange={handleDragChange}
            setDetails={setShowDetails}
          >
            {Object.keys(activeBoxes).map((key) => (
              <WindowTab
                key={key}
                id={key}
                label={key}
                {...activeBoxes[key].props}
                onClose={removeBox}
                onMinimise={revertBox}
                setShowDetails={setShowDetails}
                setShowTrack={setShowTrack}
                setDockAlign={setDockAlign}
                setDeviceId={setDeviceId}
                selectedVehiclePlate={showEventsDetails?.plate_number}
                setHighlight={setHighlight}
                removeLayerOnClose={false}
                removeRowSelection={removeSelection}
              >
                {getListDetails()}
              </WindowTab>
            ))}
          </Dnd>
        )}
      </div>
    </>
  );
};
